import React from 'react';
import PropTypes from 'prop-types';

const Gasto = ({gasto}) => (
    <li className="navbar-nav">
      <p className="d-inline-flex justify-content-between border-bottom">
          {gasto.nombre}

      <span className="bg-primary text-light p-2">${gasto.cantidad}</span>

      </p>
    </li>
);

Gasto.propTypes = {
  gasto: PropTypes.object.isRequired
}
 
export default Gasto;